import React from 'react';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import CognitiveGap from './components/CognitiveGap';
import Neurocortex from './components/Neurocortex';
import NeurocortexCards from './components/NeurocortexCards';
import HighLevelDesign from './components/HighLevelDesign';
import TechnologyStack from './components/TechnologyStack';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <CognitiveGap />
        <Neurocortex />
        <NeurocortexCards />
        <HighLevelDesign />
        <TechnologyStack />
       {/* <Team /> */}
           {/* <buraya */}
        <CallToAction />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
